<template>
    <div v-if="isLoading" class="preloader d-flex flex-column align-items-center justify-content-center">
        <div class="loader-wrap">
            <div class="spinner"></div>
            <div class="logo-wrap" v-if="logoLight">
                <img :src="logoLight" alt="Logo" class="preloader-logo" />
            </div>
        </div>
    </div>
</template>

<script>
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'

export default {
    name: 'Preloader',
    props: {
        loading: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isLoading: true
        }
    },
    computed: {
        siteDefaultsStore() {
            return useSiteDefaultsStore()
        },
        logoLight() {
            return this.siteDefaultsStore.getLogoLight()
        }
    },
    watch: {
        loading(newVal) {
            this.isLoading = newVal
        }
    },
    mounted() {
        // Auto-hide after 2 seconds as fallback
        setTimeout(() => {
            this.isLoading = false
        }, 2000)
    }
}
</script>

<style scoped>
.preloader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ffffff;
    z-index: 9999;
    transition: opacity 0.5s ease, visibility 0.5s ease;
}

.loader-wrap {
    position: relative;
    width: 120px;
    height: 120px;
}

.spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #6698C8;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.logo-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70%;
    height: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preloader-logo {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    animation: pulse 1.5s ease-in-out infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.7;
        transform: scale(0.95);
    }
}
</style>

